var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-left",
    transform: "translate(32 32) rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    "data-name": "Path 3596",
    d: "M15649.439-6280.394a1.37,1.37,0,0,1-.393-.958,1.368,1.368,0,0,1,.393-.957l4.693-4.693-4.693-4.69a1.359,1.359,0,0,1-.393-.953,1.359,1.359,0,0,1,.393-.957,1.351,1.351,0,0,1,1.916,0l5.646,5.643a1.35,1.35,0,0,1,.4.957,1.339,1.339,0,0,1-.4.958l-5.646,5.65a1.356,1.356,0,0,1-.959.393A1.351,1.351,0,0,1,15649.439-6280.394Z",
    transform: "translate(-15637.223 6303.001)",
    fill: "#42526E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.10155462c34859bc005e268458286133.svg";
export { ForwardRef as ReactComponent };